import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {Tag} from "../../../shared/interface/tag";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {DynamicDictionary} from "../../../shared/interface/dynamic-dictionary";
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {DynamicDictService} from "../../../shared/services/dynamic-dict.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-dynamic-dictionary-details',
  templateUrl: './dynamic-dictionary-details.component.html',
  styleUrls: ['./dynamic-dictionary-details.component.scss']
})
export class DynamicDictionaryDetailsComponent implements OnInit, OnDestroy {


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  dynamicDictionaryId: string;
  dynamicDictionaryObject?: DynamicDictionary;
  dynamicDictionar: ReplaySubject<DynamicDictionary> = new ReplaySubject<DynamicDictionary>(1);
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private route: ActivatedRoute,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private dynamicDictService: DynamicDictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.dynamicDictionaryId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    this.dynamicDictService.get(this.dynamicDictionaryId).subscribe((dynamicDictionary: DynamicDictionary) => {
      this.dynamicDictionar.next(dynamicDictionary);
      this.dynamicDictionaryObject = dynamicDictionary;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
